import script from "./AnalysesDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysesDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AnalysesDashboard.vue?vue&type=style&index=0&id=671959ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-671959ea"]])

export default __exports__